import { useState } from "react";
import Blog, { SingleArticle } from "../components/Blog";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SecondHero from "../components/SecondHero";
import { Link, useParams } from "react-router-dom";
import { blog as blogs } from "../data/blog";
import { useEffect } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import threads from "../assets/threads.svg";
function SingleBlogPage() {
  const [currentBlog, setCurrentBlog] = useState({});

  const { blog } = useParams();

  useEffect(() => {
    const a = blogs.find((item) => item.title === blog);
    async function fetchArticle() {
      const response = await fetch(a.article);
      const markdownContent = await response.text();
      setCurrentBlog({ ...a, markdownContent });
    }
    fetchArticle();
  }, [blog]);
  console.log(currentBlog);
  const { img, title, tag, date, markdownContent, intro } = currentBlog;
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
  }, [blog]);
  return (
    <div className="">
      <Navbar />
      <div className="max-screen max-w-5xl py-20">
        <div className="  flex flex-col gap-8 mb-20">
          <h1 className="text-3xl md:text-5xl font-bold text-primary text-center md:mb-6">
            {title}
          </h1>
          <div className="flex flex-col gap-2 items-center">
            <span className="text-primary font-medium capitalize text-lg">
              {tag}
            </span>
            <p className="text-neutral-5 font-light text-base">{date}</p>
          </div>
          <div>
            <img
              src={img}
              alt={title}
              className="aspect-video  object-cover rounded-2xl mx-auto"
            />
          </div>
          <div className="  flex flex-col justify-between  ">
            <div
              className="flex flex-col [&>*:first-child]:text-neutral-3 [&>*:first-child]:font-medium
           [&>*:first-child]:mb-4  [&_h4]:mb-2 [&_h4]:mt-4 [&_p]:mb-2">
              <ReactMarkdown children={markdownContent} />
            </div>
            <div className="flex flex-col gap-4"> </div>
          </div>
        </div>
        <ShareBlog />
        <RelatedBlogs blog={blog} />
      </div>
      <Footer />
    </div>
  );
}

export default SingleBlogPage;

const ShareBlog = () => {
  return (
    <div className=" flex flex-col items-center gap-4 ">
      <h3 className="text-primary font-semibold text-xl">
        Share it with your friends:
      </h3>
      <div className="flex items-center gap-4">
        {socialLinks.map((item, index) => {
          return (
            <a
              key={index}
              href={item.link}
              className={`h-10 w-10 flex-c text-white rounded-full bg-[${item.color}] hover:scale-125 transition-all duration-500`}
              style={{ backgroundColor: item.color }}>
              {item.icon}
            </a>
          );
        })}
      </div>
    </div>
  );
};

const socialLinks = [
  {
    icon: <FacebookIcon />,
    link: "https://www.facebook.com",
    color: "#1877f2",
  },
  { icon: <TwitterIcon />, link: "https://www.x.com", color: "#00acee" },
  {
    icon: <PinterestIcon />,
    link: "https://www.instagram.com",
    color: "#ca1f27",
  },
  {
    icon: <img src={threads} alt="" width={24} />,
    link: "https://www.instagram.com",
    color: "#000",
  },
];

const RelatedBlogs = ({ blog }) => {
  const [relatedArticles, setRelatedArticles] = useState([]);

  useEffect(() => {
    const filteredArticles = blogs.filter((article) => article.title !== blog);

    if (filteredArticles.length < 2) {
      console.warn("Not enough articles to choose from.");
      return;
    }

    const getRandomIndex = () =>
      Math.floor(Math.random() * filteredArticles.length);

    const randomIndex1 = getRandomIndex();
    let randomIndex2 = getRandomIndex();

    while (randomIndex2 === randomIndex1) {
      randomIndex2 = getRandomIndex();
    }

    const selectedArticles = [
      filteredArticles[randomIndex1],
      filteredArticles[randomIndex2],
    ];

    setRelatedArticles(selectedArticles);
  }, [blog]);
  return (
    <div className=" max-screen py-20">
      <div className="text-center mb-8">
        <h1 className="text-2xl md:text-4xl font-bold text-center mb-4 capitalize">
          Related Articles
        </h1>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8 ">
        {relatedArticles.map((item, index) => {
          return <SingleArticle key={index} {...item} />;
        })}
      </div>
    </div>
  );
};
